/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 02.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ScrollableDataListRV } from 'plugin/liferay-widgets-react-web';

import MapConfigLogicalLayerListItem from './MapConfigLogicalLayerListItem';

class MapConfigLogicalLayerChooser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedLogicalLayer: null
        };
    }

    onSelect(item, e) {
        this.setState({
            selectedLogicalLayer: item
        });

        this.props.onSelect(item);
    }

    render() {
        const { selectedLogicalLayers, selectedLayerSet, logicalLayers } = this.props;

        return (
            <React.Fragment>

                <h3>
                    Verfügbare Layer
                </h3>

                <p>
                    {selectedLayerSet ?
                        'Bitte wählen Sie einen Layer aus, den Sie hinzufügen möchten.' :
                        'Bitte wählen Sie eine Gruppierung aus.'
                    }
                </p>

                <ScrollableDataListRV list={logicalLayers}
                                      size="medium"
                                      activeIds={this.state.selectedLogicalLayer}
                                      className="map-config-logical-layer-list"
                                      ListItem={MapConfigLogicalLayerListItem}
                                      onClick={this.onSelect.bind(this)}
                                      selectedLogicalLayers={selectedLogicalLayers}
                                      selectedLayerSet={selectedLayerSet}
                />

            </React.Fragment>
        );
    }
}

MapConfigLogicalLayerChooser.propTypes = {
    selectedLogicalLayers: PropTypes.array,
    selectedLayerSet: PropTypes.object,
    logicalLayers: PropTypes.object,
    onSelect: PropTypes.func
};

export default MapConfigLogicalLayerChooser;


// WEBPACK FOOTER //
// ./js/components/MapConfigLogicalLayerChooser.jsx